import { useDisclosure } from "@chakra-ui/hooks";
import { useState } from "react";
import { MdQrCodeScanner } from "react-icons/md";
import QRCode from "react-qr-code";
import CircleButton from "./circle-button";
import { notifySimple } from "providers/toast";
import GenericButton from "./generic";
import { t } from "i18next";
import GenericDialog from "widgets/dialogs/generic";

const QrCodeButton = (props: {
  data: string;
  type: "snr" | "site";
  color?: "primary" | "secondary" | "tertiary" | "white" | string;
}) => {
  const { data, type, color = "white" } = props;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [code, setCode] = useState<string | null>(null);

  const handleClick = async () => {
    if (type === "snr") {
      let qrString = {
        snr: data ? data : "",
      };
      setCode(JSON.stringify(qrString));
    } else if (type === "site") {
      let qrString = {
        id: data ? data : "",
      };
      setCode(JSON.stringify(qrString));
    }
    onOpen();
  };

  // Copy secret
  const copyToClipboard = () => {
    navigator.clipboard.writeText(data).then(
      () => {
        notifySimple(t("notification.copied.to.clipboard"), "success");
      },
      (err) => {
        notifySimple(t("notification.failed.to.copy"), "error");
      }
    );
  };

  return (
    <div>
      <CircleButton
        icon={MdQrCodeScanner}
        size="md"
        variant="ghost"
        onClick={handleClick}
        tooltip={t("tooltip.qrcode")}
        tooltipPlacement="bottom"
        color={color}
      />
      <GenericDialog
        isOpen={isOpen}
        onExit={onClose}
        title={t("tooltip.qrcode") as string}
        size="md"
      >
        {code && (
          <div className="flex flex-col items-center justify-center gap-4 py-8">
            <QRCode
              size={256}
              style={{ height: "auto", width: "auto" }}
              value={code}
              viewBox={`0 0 256 256`}
            />
            {type === "site" && (
              <div className="text-secondary">{`Site ID: ${data}`}</div>
            )}
            <GenericButton
              text={t("button.action.copy")}
              size="md"
              onClick={copyToClipboard}
            />
          </div>
        )}
      </GenericDialog>
    </div>
  );
};

export default QrCodeButton;
